module.exports = __webpack_public_path__ + "static/img/fa4.b0ff58f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/solution/fa4.png
// module id = 9RkH
// module chunks = 3